<template>
    <div class="force-login">
        <div class="o-main-content-area">
            <!-- <h1>force login</h1> -->
        </div>
    </div>
</template>
<script>
    import service from '../services';
    import { mapGetters, mapActions } from 'vuex';
    import {global } from '../global.js';
    import { initializeProactiveRefresh } from '../api';

    export default {
        data() {
            return {}
        },
        created(){
            // console.log('route', this.$route.params.type, this.$route.params.id,  this.$route.params.token);
            let loginType=this.$route.params.type;
            if(loginType=='client'){
                // console.log('called client')
                this.$Progress.start();
                service.get('universal_login', {
                    'Authorization': atob(this.$route.params.token),
                    'userid': atob(this.$route.params.id),
                    'url': window.location.href.split('#')[0],
                }).then((res) => {
                    // console.log('login success', res);
                    if (res.data.status_code == "0") {
                        this.$Progress.fail();
                        this.$router.push({
                            path: "/login"
                        });
                    } else {
                        // console.log('correct');
                        let data = res.data.result;
                        this.$store.dispatch('userSession', data);
                        this.$cookies.set("csLogin", data.role.slug, "23h");
                        this.$cookies.set("date_format", data.user.employees[0].date_format, "23h");
                        this.$cookies.set("time_format", data.user.employees[0].time_format, "23h");
                        this.$Progress.finish();
                        if (data.role.slug != "super-admin") {
                            this.$store.dispatch('setLoginSuper', true);
                            // Store super-admin identity for audit logging
                            if (data.acting_as_super) {
                                this.$store.dispatch('setActingSuper', data.acting_as_super);
                            }
                            this.$cookies.set("time_zone", data.user.employees[0].client_employee.clients.timezone, "23h");
                            var notifyType = (data.user.employees[0].email_notification == 1) ? 'email' : 'sms';
                            this.$store.dispatch('setNotificationType', notifyType);
                            this.$store.dispatch('setClientdata', data.user.employees[0].client_employee.clients);
                            // location.reload(true);
                            window.location.replace(window.location.href.split('#')[0]);
                            if (data.role.slug == "client-admin" || data.role.slug == "power-user" && data.user.employees[0].client_employee) {
                                this.$router.push({
                                    path: "/jobList"
                                });
                            } else {
                                this.$router.push({
                                    path: "/schedule/"+btoa(this.employeeId),
                                });
                            }

                        } else {
                            // location.reload(true);
                            this.$router.push({
                                path: "/clientList"
                            });
                        }

                    }
                }).catch((err) => {
                    console.log(err);
                    this.$router.push({
                        path: "/login"
                    });
                });
            }else if(loginType=='employer'){
                this.$Progress.start();
                service.get('employer_universal_login', {
                    'Authorization': atob(this.$route.params.token),
                    'employerid': atob(this.$route.params.id),
                    'url': "http://labour." + global[0].CLIENT_BASE,
                })
                .then((res) => {
                    // console.log(res);
                    if (res.data.status_code == 0) {
                        this.$Progress.fail();
                        this.$router.push({
                            path: "/login"
                        });
                    } else {
                        // console.log('correct');
                        let data = res.data.result;

                        this.$store.dispatch('userSession', data);
                        this.$cookies.set("csLogin", data.role.slug, "23h");
                        this.credential_err = "";
                        this.$Progress.finish();
                        window.location.replace(window.location.href.split('#')[0]);
                        $('.wrapper').css('margin-left', '60px');
                        if (data.role.slug == "employer-admin" || data.role.slug == "employer") {
                            this.$router.push({
                                path: "/employerUserList"
                            });
                        } else {
                            location.reload(true);
                            this.$router.push({
                                path: "/clientList"
                            });
                        }

                    }
                    //window.location.href = "http://" + subdomain + "." + global[0].CLIENT_BASE;
                }).catch((err) => {
                    console.log(err);
                    this.$router.push({
                        path: "/login"
                    });
                });
            }else if(loginType=='employee'){

                console.log('Employee');
                this.$Progress.start();
                service.get('employee_universal_login', {
                    'Authorization': atob(this.$route.params.token),
                    'employeeid': atob(this.$route.params.id),
                    'url': "http://login." + global[0].CLIENT_BASE,
                })
                .then((res) => {
                    if (res.data.status_code == "0") {
                        this.$Progress.fail();
                        this.$notify.error({
                            title: 'Error',
                            message: 'Sorry! Unable to login'
                        })
                        this.$router.push({
                            path: "/login"
                        });
                    } else {
                        let data = res.data.result;
                        console.log(data.role);
                        this.getIntoApp(res);
                    }
                }).catch((err) => {
                    console.log(err);
                    this.$router.push({
                        path: "/login"
                    });
                });
            }else{
                this.$router.push({
                    path: "/login"
                });
            }
        },

        methods: {
            async getIntoApp(res) {
                localStorage.removeItem('vuex');
                if (res.data.status_code == 0) {
                    this.$Progress.fail();
                    this.loading = false;
                    this.credential_err = res.data.status_message;
                } else {
                    let data = res.data.result;
                    this.$store.dispatch('setTokenExpiry', data.token_expiry);
                    this.$store.dispatch('userSession', data);
                    initializeProactiveRefresh();
                    this.$store.dispatch('setLoginSuper', false);
                    this.$cookies.set("csLogin", data.role.slug, "23h");
                    this.$cookies.set("csLogin", data.role.slug, "23h",'/mobile');
                    this.credential_err = "";
                    this.$Progress.finish();
                    $('.wrapper').css('margin-left', '60px');
                    let self = this;
                    if (data.role.slug == "client-admin" || data.role.slug == "employee" || data.role.slug == "power-user" || data.role.slug == "power-user-minus" || data.role.slug == "auditor") {
                        if(data.user && data.user.employees && data.user.employees.length && data.user.employees[0].client_employee && data.user.employees[0].client_employee.clients){
                            this.$cookies.set("time_zone", data.user.employees[0].client_employee.clients.timezone, "23h");
                            this.$cookies.set("date_format", data.user.employees[0].date_format, "23h");
                            this.$cookies.set("time_format", data.user.employees[0].time_format, "23h");
                            this.$cookies.set("powerSteward", data.user.employees[0].client_employee.clients.power_steward, "23h");
                            var notifyType = (data.user.employees[0].email_notification == 1) ? 'email' : 'sms';

                            this.$store.dispatch('setNotificationType', notifyType);
                            this.$store.dispatch('setClientdata', data.user.employees[0].client_employee.clients);
                        }
                        if (data.role.slug == "client-admin" || data.role.slug == "power-user" || data.role.slug == "power-user-minus") {
                            this.$store.dispatch('setLastOpenJob', 0);

                            if(data.role.slug == "power-user" || data.role.slug == "power-user-minus"){
                                this.$router.push({
                                    path: "/switchClient"
                                });
                            }
                            else{
                                this.$router.push({
                                    path: "/jobList"
                                });
                            }
                        } else { // role='employee'
                            if(document.getElementsByTagName('body')[0].clientWidth < 700)
                            { 
                                // mobile screen check
                                this.$cookies.set("csLogin", data.role.slug, "23h",'/mobile');
                                this.$cookies.set("date_format", data.user.employees[0].date_format, "23h", '/mobile');
                                this.$cookies.set("time_format", data.user.employees[0].time_format, "23h", '/mobile');
                                window.location.href = window.location.href.split('#')[0]+"mobile/";
                            } else{

                                // role='employee'
                                //for heard refresh.
                                //location.reload(true);


                                // this.$router.push({
                                //     path: "/switchClient"
                                // });
                                this.$router.push({
                                    path: "/myProfile"
                                });
                                // this.$router.push({
                                //     path: "/schedule/"+btoa(this.employeeId),
                                // });
                            }
                        }

                    } else if(data.role.slug == "employer-admin" || data.role.slug == "employer"){

                        // console.log("Hi I am Employer Admin.");
                        window.location.reload(true);
                        this.$router.push({
                            path: "/employerJobList"
                        });

                    } else if(data.role.slug == "super-admin") {
                        //location.reload(true);
                        this.$router.push({
                            path: "/clientList"
                        });
                    }                                
                }
                this.loading=false;
            }
        },
        mounted(){
            $('.force-login').parent('.wrapper').css('margin-left', '0');
        }
    }
</script>
<style scoped>

</style>
